import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { NavMarker } from 'react-rhumb';
import UIResultsMessage from 'UIComponents/results/UIResultsMessage';
import ErrorMessage from '../../../components/ErrorMessage';
import MasonryGrid from '../../../components/MasonryGrid';
import { PrerenderReady } from '../../../components/Prerender';
import ProfileCard, { ProfileCardSkeleton } from '../../../components/ProfileCard';
import { useDirectoryUsers } from '../directoryQueries';

const UsersSearchGrid = () => {
  const {
    users,
    usersLoading,
    usersError,
    resultsPerPage
  } = useDirectoryUsers();

  if (usersError) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "DIRECTORY_LOAD_FAILURE",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        type: "error"
      })
    });
  }

  if (usersLoading) {
    return /*#__PURE__*/_jsx(MasonryGrid, {
      children: [...Array(resultsPerPage).keys()].map(i => /*#__PURE__*/_jsx(ProfileCardSkeleton, {
        "data-test-id": "profile-card-skeleton"
      }, i))
    });
  }

  if (users && users.length === 0) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "DIRECTORY_LOADED",
      children: /*#__PURE__*/_jsx(UIResultsMessage, {
        illustration: "empty-state-charts",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "connectDotCom.directory.noResults"
        })
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(NavMarker, {
      name: "DIRECTORY_LOADED"
    }), /*#__PURE__*/_jsx(MasonryGrid, {
      children: users.map(user => /*#__PURE__*/_jsx(ProfileCard, {
        name: user.displayName,
        jobTitle: user.jobTitle,
        goal: user.networkGoal,
        products: user.products,
        username: user.userName,
        userId: user.userId,
        avatarHash: user.avatarHash,
        avatarLastUpdated: user.avatarLastUpdated
      }, user.id))
    })]
  });
};

export default UsersSearchGrid;